import { PROMOTION_MATRIX_STATUS } from "../data/promotion-matrix-status.data";

export type PromotionMatrixStatus = typeof PROMOTION_MATRIX_STATUS[number];
